import isEmpty from 'lodash/isEmpty';
import { useNavigate } from 'react-router-dom';
import { FINISH_INFORMATION_QUESTIONNAIRES, QUESTIONNAIRES_SETTINGS_MAP } from '@thinknet-gmbh/platform-common';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useCreateEmployeeQuestionnaireSetting } from 'src/hooks/employee-questionnaire-settings/create-employee-questionnaire-settings.hook';

import { EditEmployeeQuestionnaireSettingsForm } from '../employee-questionnaire-settings-form';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';

const NewEmployeeQuestionnaireSettings = () => {
  const navigate = useNavigate();

  const currentCompanyId = useGetCurrentCompanyId();

  const createEmployeeQuestionnaireSetting = useCreateEmployeeQuestionnaireSetting({
    onSuccess: () => navigate(`${ROUTES.settings}?type=${SETTINGS_PAGES.employeeQuestionnaire}`),
  });

  const onFinishHandler = (values: any, acceptedList: string[]) => {
    if (isEmpty(acceptedList)) {
      return showNotification({
        type: NOTIFICATION_TYPE.error,
        message: 'Selected some items',
      });
    }

    const isMiniJobRequired = acceptedList.includes(
      FINISH_INFORMATION_QUESTIONNAIRES.miniJobDocument
    );

    const { uploadedFile } = values;

    const isFileValid = uploadedFile && uploadedFile?.file.status !== 'removed';

    if (isMiniJobRequired && uploadedFile && uploadedFile?.file.status === 'removed') {
      return showNotification({
        type: NOTIFICATION_TYPE.error,
        message: 'File not selected',
      });
    }


    return createEmployeeQuestionnaireSetting({
      variables: {
        payload: {
          name: values.name,
          settings: acceptedList,
          companyId: currentCompanyId,
          supervisorEmailTemplateId: values?.supervisorEmailTemplateId,
          applicantEmailTemplateId: values?.applicantEmailTemplateId,
          ...(values?.privacyPolicyLink && { privacyPolicyLink: values.privacyPolicyLink }),
          miniJobDocumentId: isFileValid ? uploadedFile.file : null,
        },
      },
    });
  };

  return (
    <EditEmployeeQuestionnaireSettingsForm
      acceptedListData={[]}
      questionnaireSetting={{}}
      previewListData={QUESTIONNAIRES_SETTINGS_MAP}
      onFinishHandler={onFinishHandler}
    />
  );
};

export default NewEmployeeQuestionnaireSettings;
